"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericFilterOperation = void 0;
/**
 * Used to define a generic comparator operation for filtering where comparator is supplied
 * @param field the name of the field
 * @param value the value of the field
 * @param operator the comparison operator
 */
class GenericFilterOperation {
    constructor(field, value, operator) {
        this.field = field;
        this.value = value;
        this.operator = operator;
    }
}
exports.GenericFilterOperation = GenericFilterOperation;
